import { Link, SelectField } from '@flos/react-ui';
import { useHippoText } from '../../../../../hooks/useHippoText';
import type { AttributeChangeProps } from '../../../types';
import { type ACCFulltimeOrLeisure_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { isOpcDataFilledAtom } from '../../../../../recoil/atoms/isOpcDataFilledAtom';
import { infoModalVariantOpcAtom } from '../../../../../recoil/atoms/infoModalVariantOpcAtom';
import { callMeVariantOpcAtom } from '../../../../../recoil/atoms/callMeVariantOpcAtom';
import { getCoverableInfoSelector } from '../../../../../recoil/selectors/getCoverableInfoSelector';
import { isOpcFetchingAtom } from '../../../../../recoil/atoms/isOpcFetchingAtom';
import { getOPCCoverableAttributeSelector } from '../../../../../recoil/selectors/getOPCCoverableAttributeSelector';

export const fulltimeLeisureOptions: Array<{ label: string; value: ACCFulltimeOrLeisure_Top }> = [
    {
        label: 'Heltid',
        value: 'FullTime'
    },
    {
        label: 'Fritid',
        value: 'Leisure'
    }
];

const mapFulltimeLeisureToLabel = (fulltimeLeisureValue: string): string => {
    return (
        fulltimeLeisureOptions.find((option) => option.value === fulltimeLeisureValue)?.label ?? ''
    );
};

const AdultAccFulltimeLeisureChange = ({
    updateCoverableAttribute
}: AttributeChangeProps): React.JSX.Element => {
    const getHippoText = useHippoText();
    const setInformationModalVariant = useSetRecoilState(infoModalVariantOpcAtom);
    const currentOPCAttribute = useRecoilValue(getOPCCoverableAttributeSelector)?.adultAccident
        ?.fulltimeOrLeisure;
    const setIsOpcDataFilled = useSetRecoilState(isOpcDataFilledAtom);
    const isOpcFetching = useRecoilValue(isOpcFetchingAtom);

    const setCallMeVariant = useSetRecoilState(callMeVariantOpcAtom);
    const { isAdultAccFulltime } = useRecoilValue(getCoverableInfoSelector);
    return (
        <>
            <h6>{getHippoText('DSS-COVERABLE-DETAILS-STEP-FULLTIME-OR-LEISURE-SUBHEADER')}</h6>
            <SelectField
                label={getHippoText('DSS-OPC-INPUT-LABEL')}
                options={fulltimeLeisureOptions}
                placeholder={
                    isAdultAccFulltime
                        ? mapFulltimeLeisureToLabel('FullTime')
                        : mapFulltimeLeisureToLabel('Leisure')
                }
                onChange={(e) => {
                    const selectedIndex = e.target.selectedIndex;
                    const { value } = e.target.options[selectedIndex];
                    if (isAdultAccFulltime && (value as ACCFulltimeOrLeisure_Top) === 'Leisure') {
                        setCallMeVariant('fulltimeToLeisure');
                        return;
                    }
                    updateCoverableAttribute({
                        fulltimeOrLeisure: value as ACCFulltimeOrLeisure_Top
                    });
                    setIsOpcDataFilled(true);
                }}
                disabled={isOpcFetching}
                defaultValue={currentOPCAttribute}
            ></SelectField>
            <div className="u-spacing-inset-bottom-6">
                <Link
                    onClick={() => {
                        setInformationModalVariant('adultAccFulltimeLeisure');
                    }}
                    className="u-color-primary-2-base"
                >
                    {getHippoText(
                        'DSS-COVERABLE-DETAILS-STEP-FULLTIME-OR-LEISURE-INFORMATION-MODAL-BUTTON'
                    )}
                </Link>
            </div>
        </>
    );
};

export default AdultAccFulltimeLeisureChange;
